<template>
  <div class="box flex h-full flex-col items-center justify-center gap-4 p-8">
    <FontAwesomeIcon
      :icon="['fal', 'route']"
      class="text-6xl text-primary-500"
    />
    <p class="text-6xl font-bold text-gray-900 dark:text-white">404</p>
    <h1 class="text-xl font-semibold capitalize-first">
      {{ $t('global.page_not_found') }}
    </h1>
    <p class="max-w-md text-center text-gray-600 dark:text-gray-300">
      {{ $t('global.page_not_found_description') }}
    </p>
    <div class="mt-2 flex gap-2">
      <BaseButton
        :title="$t('button.back')"
        icon="long-arrow-left"
        inverse-icon-order
        color="dark"
        @click="$router.back()"
      />
      <BaseButton
        :title="$t('navigation.work_progress')"
        icon="folder-open"
        color="primary"
        @click="$router.push({ name: 'work_progress_route' })"
      />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * Shown inside the layout for any URL no route matches.
 */
export default {
  name: 'TheNotFoundPage',
  components: { FontAwesomeIcon }
}
</script>
